import { PatientInfoFormInput } from 'containers/patient/PatientModalContainer';
import { IPatient, TRememberPatient } from 'lib/types/patientTypes';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import { ForwardedRef } from 'react';
import { createStoreWithSetters } from './utils';

interface IStoreProps {
  // quickstart info
  patientData: PatientInfoFormInput | null;
  buttonClickType: null | 'scan' | 'project';
  projectListLoadSuccess: boolean;
  projectList: any[];
  isNewPatient: boolean;
  scanBtnState: boolean;
  projectBtnState: boolean;
  editPatientBtnState: boolean;
  isOpenPatientModal: boolean;
  patientModalType: 'new' | 'edit';
  isSearchFocus: boolean;
  patientPage: number;
  projectPage: number;
  rememberPatient: TRememberPatient[];
  isOpenSearchResult: boolean;
  selectedPatientCode: string;
  patientList: IPatient[];
  patientListLoadSuccess: boolean;
  isChangeKeyword: boolean;
  searchData: string;
  prevSearchKeyword: string;
  searchKeyword: string;
  searchInputRef: ForwardedRef<HTMLInputElement>;
  searchResultRef: React.ForwardedRef<HTMLDivElement>;
  scanButtonRef: React.ForwardedRef<HTMLDivElement>;
  projectButtonRef: React.ForwardedRef<HTMLDivElement>;
}

export const useQuickstartStore = createStoreWithSetters<IStoreProps>(
  {
    patientData: null,
    buttonClickType: null,
    projectListLoadSuccess: false,
    projectList: [],
    isNewPatient: false,
    scanBtnState: false,
    projectBtnState: false,
    editPatientBtnState: false,
    isOpenPatientModal: false,
    patientModalType: 'new',
    isSearchFocus: false,
    patientPage: 1,
    projectPage: 1,
    rememberPatient: [],
    patientListLoadSuccess: false,
    isOpenSearchResult: false,
    selectedPatientCode: '',
    patientList: [],
    isChangeKeyword: false,
    searchData: '',
    prevSearchKeyword: '',
    searchKeyword: '',
    searchInputRef: null,
    searchResultRef: null,
    scanButtonRef: null,
    projectButtonRef: null,
  },
  'quickstart',
);
